<template>
  <van-overlay :show="show">
    <div class="user-lock-dialog">
      <img class="warn-icon" src="@/assets/icon_tips_big.png" />
      <div class="warn-desc">
        {{ $t('login.userAccountLocked') + $t('login.pleaseCall') + $t('login.serviceHotline') }}
      </div>
      <div class="phone-row">
        <div class="phone-type">({{ $t('login.hongkongHotline') }})</div>
        <div class="phone-num">+852 23709538</div>
      </div>
      <div class="phone-row">
        <div class="phone-type">({{ $t('login.otherHotline') }})</div>
        <div class="phone-num">400 801 6688</div>
      </div>
      <div class="btn-bar">
        <wb-primary-btn
          :msg="$t('common.confirm')"
          type="primary"
          :cssStyle="{ height: '40px', lineHeight: '40px' }"
          @tap="$emit('close')"
        />
      </div>
    </div>
  </van-overlay>
</template>

<script>
  import WbPrimaryBtn from '@/components/wb-primary-btn.vue'

  export default {
    name: 'user-lock-dialog',

    components: {
      WbPrimaryBtn
    },

    props: {
      show: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="scss" scoped>
.user-lock-dialog {
  width: 315px;
  height: 298px;
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 8px;
  text-align: center;

  .warn-icon {
    width: 56px;
    height: 56px;
    margin: 28px 0 20px 0;
  }

  .warn-desc {
    font-size: 16px;
    color: #121212;
    line-height: 26px;
    padding-bottom: 16px;
  }

  .phone-row {
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1.4;
    font-size: 16px;
    padding-bottom: 16px;

    .phone-type {
      color: #666666;
      margin-right: 4px;
    }

    .phone-num {
      color: #1890ff;
    }
  }

  .btn-bar {
    padding: 16px 30px;
  }
}
</style>
